import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ExchangeAvailabilityOption } from 'src/app/core/models/voluntary-change.model';

@Component({
  selector: 'app-exchange-flight',
  templateUrl: './exchange-flight.component.html',
  styleUrls: ['./exchange-flight.component.scss']
})
export class ExchangeFlightComponent {
  @Input() option: ExchangeAvailabilityOption;
  @Input() showFare = true;
  @Input() isInvoluntary: boolean;
  @Input() showExtra = true;
  @Input() isHeader:boolean;

  @Output() selectAll = new EventEmitter<string>();
  @Output() changeClass = new EventEmitter<string>();
}
